import useSWR from 'swr';

import { getIssueCase } from 'src/utils/firebase/firebase-short-cut';

const useIssueCase = (id: string | undefined) => {
  const {
    data,
    isLoading: issueCaseLoading,
    error: issueCaseError,
  } = useSWR(id ? id : null, getIssueCase, {
    revalidateOnFocus: false,
    errorRetryCount: 2,
  });

  return {
    issueCase: data,
    issueCaseLoading,
    issueCaseError,
  };
};

export default useIssueCase;
